import { endpoints } from "../apiEndpoints/apiEndpoints";
import apiService from "../services/apiCore";

// ✅ Add Employee
export const addEmployeeAPI = async ({ companyId, data }) => {
  try {
    const payload = { ...data, company_id: companyId };
    const response = await apiService.post(endpoints.addEmployee, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Update Employee
export const updateEmployeeAPI = async ({ companyId, employeeId, data }) => {
  try {
    const payload = { 
      ...data,
      company_id: companyId,
      employee_id: employeeId 
    };
    const response = await apiService.put(endpoints.updateEmployee, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Delete Employee
export const deleteEmployeeAPI = async ({ company_id, employee_id }) => {
  try {
    const payload = { 
      company_id: company_id,
      employee_id: employee_id 
    };
    
    console.log('Delete API Payload:', payload);
    console.log('Endpoint:', endpoints.deleteEmployee);
    
    const response = await apiService.delete(endpoints.deleteEmployee, payload);
    return response.data;
  } catch (error) {
    console.error('Delete API Error:', error);
    throw error;
  }
};

// ✅ Get Employees List (with pagination + search)
export const getEmployeesListAPI = async ({
  companyId,
  page = 1,
  limit = 10,
  search = "",
  sort,
  order,
} = {}) => {
  try {
    const params = { company_id: companyId, page, limit, search };
    if (sort) params.sort = sort;
    if (order) params.order = order;
    const response = await apiService.get(endpoints.getEmployeesList, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get All Employees (simple get - accepts params like { status: 'unassigned' })
export const getEmployeesAPI = async (params = {}) => {
  try {
    const response = await apiService.get(endpoints.getHrEmployee, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Employee Detail
export const getEmployeeDetailAPI = async ({ companyId, employeeId }) => {
  try {
    const params = { 
      company_id: companyId,
      employee_id: employeeId 
    };
    const response = await apiService.get(endpoints.getEmployeeDetail, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Company Employee Info by ID
export const getCompanyEmployeeInfoAPI = async ({ companyEmployeeId }) => {
  try {
    const response = await apiService.get(
      endpoints.getCompanyEmployeeInfo.replace('{companyEmployeeId}', companyEmployeeId)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Lock / Unlock Company Employee
export const lockCompanyEmployeeAPI = async ({ company_employee_id, status }) => {
  try {
    const payload = { company_employee_id, status };
    const response = await apiService.put(endpoints.lockCompanyEmployee, payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Import Employees via CSV
export const importEmployeesCsvAPI = async ({ companyId, formData }) => {
  try {
    const params = { company_id: companyId };
    const response = await apiService.postFormData(endpoints.importEmployeesCsv, formData, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Employee Sessions
export const getEmployeeSessionsAPI = async ({ employeeId, page, limit, search ,view}) => {
  try {
    const params = {};
    if (employeeId) params.company_employee_id = employeeId;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;
    if (view) params.view = view;

    const response = await apiService.get(endpoints.getEmployeeSessions, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Assessment Link for Session
export const getSessionAssessmentLinkAPI = async ({ sessionId, employeeId }) => {
  try {
    const params = { company_employee_id: employeeId };
    const response = await apiService.get(
      endpoints.getSessionAssessmentLink.replace('{sessionId}', sessionId),
      params
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Document Link for Session
export const getSessionDocumentLinkAPI = async ({ sessionId, employeeId }) => {
  try {
    const params = { company_employee_id: employeeId };
    const response = await apiService.get(
      endpoints.getSessionDocumentLink.replace('{sessionId}', sessionId),
      params
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Session Assignment Result for Session
export const getSessionAssignmentResultAPI = async ({ sessionId, employeeId }) => {
  try {
    const params = { company_employee_id: employeeId };
    const response = await apiService.get(
      endpoints.getSessionAssignmentResult.replace('{sessionId}', sessionId),
      params
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Employee Assignments (My Assignments)
export const getEmployeeAssignmentsAPI = async ({ employeeId, page, limit, search , view }) => {
  try {
    const params = {};
    if (employeeId) params.company_employee_id = employeeId;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;
    if (view) params.view = view;

    const response = await apiService.get(endpoints.getEmployeeAssignments, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Employee Documents (My Documents)
export const getEmployeeDocumentsAPI = async ({ employeeId, page, limit, search }) => {
  try {
    const params = {};
    if (employeeId) params.employee_id = employeeId;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;
    
    const response = await apiService.get(endpoints.getEmployeeDocuments, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Employee Tools (My Tools)
export const getEmployeeToolsAPI = async ({ employeeId, page, limit, search } = {}) => {
  try {
    const params = {};
    if (employeeId) params.company_employee_id = employeeId;
    if (page) params.page = page;
    if (limit) params.limit = limit;
    if (search) params.search = search;

    const response = await apiService.get(endpoints.getEmployeeTools, params);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Assignment Questions
export const getAssignmentQuestionsAPI = async ({ sessionAssignmentId }) => {
  try {
    const response = await apiService.get(
      endpoints.getAssignmentQuestions.replace('{sessionAssignmentId}', sessionAssignmentId)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Submit Assignment Answers
export const submitAssignmentAnswersAPI = async ({ data }) => {
  try {
    const response = await apiService.post(endpoints.submitAssignmentAnswers, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

// ✅ Get Assignment Answers
export const getAssignmentAnswersAPI = async ({ sessionAssignmentId }) => {
  try {
    const response = await apiService.get(
      endpoints.getAssignmentAnswers.replace('{sessionAssignmentId}', sessionAssignmentId)
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};